module.exports = "pegasus/assets/theme6/medium/2.jpg";